import { useAuthenticator } from "@aws-amplify/ui-react";
import { operationType, resourceType } from "../interfaces/roles";
import { useEffect } from "react";

import { useGetRolesQuery } from "../redux/slices/api.slice";

const usePermissioned = (operation: operationType, resource: resourceType) => {
  const { user } = useAuthenticator();
  const { data: roles } = useGetRolesQuery("");

  const session = user.getSignInUserSession();
  const payload = session.getAccessToken().decodePayload();

  const accountRoles = payload["cognito:groups"];
  useEffect(() => {
    if (accountRoles) {
      window.localStorage.setItem("role", JSON.stringify(accountRoles));
    }
  }, [accountRoles]);

  if (!session) {
    return { isPermissioned: false };
  }

  if (!Array.isArray(accountRoles)) {
    return { isPermissioned: false };
  }

  const confirmOperationPermission = () => {
    const operations = accountRoles.reduce((acc, cur) => {
      const rolePermissions = (roles?.[cur]?.permissions[resource] || []).filter(
        (item) => !acc.includes(item)
      );
      return [...acc, ...rolePermissions];
    }, []);

    

    return operations.includes(operation);
  };

  return {
    isPermissioned: confirmOperationPermission(),
  };
};

export default usePermissioned;
